import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/fee-setups', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const store = data => {
  return httpClient
    .post('/api/fee-setups', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/fee-setups/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = ({ id, data }) => {
  return httpClient
    .put(`/api/fee-setups/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/fee-setups/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const paymentTerm = (Options = {}) => {
  return httpClient
    .get('/api/fee-setups/payment-terms', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const shift = (Options = {}) => {
  return httpClient
    .get('/api/fee-setups/payment-shifts', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const copyFee = data => {
  return httpClient
    .post('/api/fee-setups/copies', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const exportExcel = attributes => {
  return httpClient
    .post('/api/fee-setups/export-excels', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const setInactive = id => {
  return httpClient
    .get(`/api/fee-setups/${id}/inactive`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  update,
  destroy,
  store,
  paymentTerm,
  shift,
  copyFee,
  exportExcel,
  setInactive
}
